import React, {useMemo} from 'react';

// @ts-expect-error
import formatters from 'notebook/mediocre/formatted-text/formatters';

import {MediocreSearchResultProps} from './SearchResultProps';

export interface SearchableTextProps extends MediocreSearchResultProps {
  text: string;
}

export default function SearchableText({
  text,
  searchResultsTree,
  selectedSearchResultTree,
}: SearchableTextProps): JSX.Element {
  const html = useMemo(
    () =>
      formatters.renderHTML(text, formatters.defaultFormats(), {searchResultsTree, selectedSearchResultTree}),
    [text, searchResultsTree, selectedSearchResultTree]
  );
  // oxlint-disable-next-line react/no-danger
  return <span dangerouslySetInnerHTML={{__html: html}} />;
}
